import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import StandardButton from "../../../../components/StandardButton";
import EmptyStateCard from "../../../../components/EmptyStateCard";
import useEvents from "../../../../hooks/useEvents";

type EmptyCustomGroupsProps = {
  onAddGroup: () => void;
};

const EmptyCustomGroups = ({ onAddGroup }: EmptyCustomGroupsProps) => {
  const events = useEvents();
  
  return (
    <Box data-testid="EmptyCustomGroupsView" style={{ margin: 24 }}>
      <EmptyStateCard text="No custom groups yet. Create custom chat groups to communicate with specific groups of clients." />
      <Box
        style={{
          marginTop: 24,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack style={{ maxWidth: 500 }}>
          <Typography style={{ textAlign: "center", marginBottom: 16 }}>
            Custom groups let you create group chats with selected clients.
            Perfect for team challenges, group coaching, or discussing specific
            plans with multiple clients at once.
          </Typography>
          <StandardButton
            data-testid="EmptyCustomGroupsView-Button"
            variant="primary"
            onClick={() => {
              onAddGroup();
              events.logButtonClick({
                buttonName: "Create Your First Custom Group",
                pageName: "Messages",
                tabName: "Custom Groups Empty",
              });
            }}
            style={{ fontSize: 18 }}
          >
            Create Your First Custom Group
          </StandardButton>
        </Stack>
      </Box>
    </Box>
  );
};

export default EmptyCustomGroups;